import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import { t } from "i18next";
import axios from "axios";
import {
  ArrowLeftOutlined,
  CloudUploadOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import {
  Form,
  Button,
  Col,
  Row,
  Upload
} from "common/elements";
import { Util } from "common/util";

export default function importForm({
  title = "",
  onBackLink = "",
  textUpload = "",
  fileName = "",
  url = "",
  titleBeforeUpload = "",
  textBeforeUpload = "",
}) {
  return () => {
    const [display, setDisplay] = useState("");
    const navigate = useNavigate();

    const onBack = () => {
      navigate(onBackLink);
    };

    const uploadExcelFile = (options) => {
      setDisplay("none");
      const { onSuccess, onError, file } = options;
      const formData = new FormData();
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${Util.getInstance().getAccessToken()}`,
        },
      };
      formData.append("csv", file, file.name);
      try {
        axios
          .post(url, formData, config)
          .then(() => {
            onSuccess("Ok");
            swal(t("text_success_import"), {
              buttons: ["Back To List", "New Import"],
              icon: "success",
            })
              .then((isNewImport) => {
                if (isNewImport) {
                  window.location.reload();
                } else {
                  onBack();
                }
              });
          })
          .catch((err) => {
            onError({ err });
            Util.getInstance().sweetAlertMessage(err.response?.data?.error?.message, "error");
          });
      } catch (err) {
        onError({ err });
        Util.getInstance().sweetAlertMessage(err.message, "error");
      }
    };
    const handlRemove = () => {
      setDisplay("");
    };

    const handleBeforeUpload = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          swal({
            title: titleBeforeUpload,
            text: textBeforeUpload,
            icon: "warning",
            buttons: ["No, cancel", "Yes, import!"]
          }).then((yes) => {
            if (yes) {
              resolve(file);
            } else {
              reject();
              handlRemove();
            }
          });
        };
        reader.readAsDataURL(file);
      });
    };

    return (
      <Form layout="vertical" className="personal-form " id="import">
        <div className="btn-navigation">
          <Row>
            <Col span={12}>
              <div className="pull-left">
                <Button className="btn-import-back" onClick={() => onBack()}>
                  <ArrowLeftOutlined />
                  <span>{t("text_back")}</span>
                </Button>
                <span className="title">{title}</span>
              </div>
            </Col>
            <Col span={12}>
              <div className="pull-right">
                <Button
                  type="primary"
                  icon={<DownloadOutlined />}
                  className="btn-download-template"
                >
                  <a
                    href={process.env.PUBLIC_URL + `/${fileName}`}
                    download={`${fileName}`}
                  >
                    {t("text_download_template")}
                  </a>
                </Button>
              </div>
            </Col>
          </Row>
        </div>
        <div style={{ display: "flex", height: "69vh", justifyContent: "center", alignItems: "center" }}>
          <Upload
            accept={"application/vnd.ms-excel,.csv,.xls,.xlsx"}
            customRequest={uploadExcelFile}
            beforeUpload={handleBeforeUpload}
            className="image-upload-grid"
            maxCount={1}
            onRemove={handlRemove}
          >

            <div className="import-content" style={{ display: `${display}` }}>
              <div className="cloud-upload-icon">
                <CloudUploadOutlined />
              </div>
              <div className="text-upload">
                <span>{textUpload}</span>
              </div>
              <div className="text-upload-file">
                <span>{t("text_upload_files_drag_and_drop")}</span>
              </div>
              <div className="btn-upload-file">
                <Button type="primary">
                  {t("text_choose_a_file_to_upload")}
                </Button>
              </div>
            </div>

          </Upload>
        </div>
      </Form>
    );
  };
}
